import { TImageField, TStringField } from '../../../types/sitecore.types';
import { TSplashComponentFields, TSplashComponentProps, TSplashComponentRegion } from '../types/splashComponent.types';

export class SplashComponentModel {
  private readonly fields?: TSplashComponentFields;

  constructor(props: TSplashComponentProps) {
    this.fields = props?.fields;
  }

  get regions(): TSplashComponentRegion[] {
    return this.fields?.regions ?? [];
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get copyrightText(): TStringField | undefined {
    return this.fields?.copyrightText;
  }

  get headerLogo(): TImageField | undefined {
    return this.fields?.headerLogo;
  }

  get footerLogo(): TImageField | undefined {
    return this.fields?.footerLogo;
  }
}

